import { CircularProgress, Typography } from '@mui/material';

import { AcFullScreenLoaderProps } from './AcFullScreenLoader.types';

import './style.scss';

const AcFullScreenLoader = ({
  text,
  spinnerColor,
  textColor
}: AcFullScreenLoaderProps) => {
  return (
    <div className="ac-full-screen-loader">
      <CircularProgress sx={{ color: spinnerColor || '#FFFFFF' }} />
      <Typography sx={{ color: textColor || '#FFFFFF' }}>
        {text || 'Loading'}
      </Typography>
    </div>
  );
};

export default AcFullScreenLoader;
